<template>
  <b-card>
    <validation-observer ref="simpleRules">
      <b-form @submit.prevent>
        <b-row>
          <b-col md="6">
            <b-form-group
              label="O que sera cobrado?"
              label-for="charge"
            >
              <validation-provider
                #default="{ errors }"
                rules="required"
                name="O que sera cobrado"
              >
                <b-form-input
                  id="charge"
                  v-model="req.product.name"
                  placeholder="informe o nome do produto "
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="Valor por cobrança"
              label-for="value"
            >
              <validation-provider
                #default="{ errors }"
                name="Valor total"
                rules="required|recurrenceValue"
              >
                <b-form-input
                  id="value"
                  v-model="value"
                  v-money
                  placeholder="insira o valor total da venda "
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-row>
              <b-col
                md="12"
                lg="6"
              >
                <b-form-group
                  label="Nome do pagador"
                  label-for="name"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Nome do Pagador"
                    rules="required"
                  >
                    <b-form-input
                      id="name"
                      v-model="payerName"
                      :readonly="readOnlyCustomer"
                      placeholder="informe o nome do pagador "
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
              <b-col
                md="12"
                lg="6"
              >
                <b-form-group
                  label="Documento do pagador"
                  label-for="document"
                >
                  <validation-provider
                    #default="{ errors }"
                    name="Documento do pagador"
                    :rules="`required|${isForeigner ? '' : 'document'}`"
                  >
                    <b-form-input
                      id="document"
                      v-model="tax_id"
                      v-mask="isForeigner ? ['#################'] : [
                        '###.###.###-##',
                        '##.###.###/####-##',
                        '##.###.###',
                      ]"
                      :readonly="readOnlyCustomer"
                      placeholder="informe o documento do pagador "
                      :state="errors.length > 0 ? false : null"
                    />
                    <small class="text-danger">{{ errors[0] }}</small>
                  </validation-provider>
                </b-form-group>
              </b-col>
            </b-row>

            <b-form-group
              label-for="expiration_date"
              label="Validade do Link"
            >
              <validation-provider
                #default="{ errors }"
                name="Validade do Link"
                rules="required|dueDateRecurrence"
              >
                <b-form-input
                  id="expiration_date"
                  v-model="req.payment.expiration_date"
                  type="date"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
            <b-form-group
              label="Data da Primeira cobrança"
              label-for="start_date"
            >
              <validation-provider
                #default="{ errors }"
                name="Data de Vencimento"
                :rules="`required|firstCharge|recurrenceDate:${req.payment.expiration_date}|recurrenceDateFinal`"
              >
                <b-form-input
                  id="start_date"
                  v-model="req.payment.start_date"
                  type="date"
                  placeholder="informe a data inicial da cobrança"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="6">
            <b-form-group
              label="Descrição (opcional)"
              label-for="description"
              type="text-area"
              placeholder="digite a descrição do produto "
            >
              <validation-provider
                #default="{ errors }"
                name="Descrição"
              >
                <textarea
                  id="exampleFormControlTextarea1"
                  v-model="req.product.description"
                  class="form-control"
                  rows="3"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="E-mail do pagador"
              label-for="email"
            >
              <validation-provider
                #default="{ errors }"
                name="E-mail"
                rules="required|email"
              >
                <b-form-input
                  id="email"
                  v-model="email"
                  :readonly="readOnlyCustomer"
                  placeholder="granger007@hogward.com"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="Período"
              label-for="period"
            >
              <validation-provider
                #default="{ errors }"
                name="Período"
                rules="required"
              >
                <b-form-select
                  id="period"
                  v-model="req.payment.period"
                  :options="frequencyOptions"
                  :state="errors.length > 0 ? false : null"
                />
                <small class="text-danger">{{ errors[0] }}</small>
              </validation-provider>
            </b-form-group>

            <b-form-group
              label="Parcelas"
              label-for="installments"
            >
              <validation-provider
                #default="{ errors }"
                name="Parcelas"
                rules="required"
              >
                <b-form-input
                  id="installments"
                  v-model="req.payment.installments"
                  v-mask="'####'"
                  :state="errors.length > 0 ? false : null"
                  type="number"
                />
                <small class="text-danger">
                  {{ errors[0] }}
                </small>
              </validation-provider>
            </b-form-group>
          </b-col>

          <b-col md="12">
            <b-form-group
              label-for="is-foreinger"
              label="Cliente é estrangeiro?"
            >
              <b-form-checkbox
                id="is-foreinger"
                v-model="isForeigner"
              />
            </b-form-group>
          </b-col>
        </b-row>
        <b-button
          variant="primary"
          class="button-generate"
          @click="validationForm()"
        >
          Gerar
        </b-button>
      </b-form>
    </validation-observer>
  </b-card>
</template>

<script>
import {
  BRow,
  BCol,
  BFormGroup,
  BFormInput,
  BForm,
  BButton,
  BCard,
  BFormSelect,
  BFormCheckbox,
} from 'bootstrap-vue'
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import { required } from '@validations'
import Ripple from 'vue-ripple-directive'
import { generateLink } from '@/service/transaction-generator/transaction-generator'
import { callLoading } from '@/service/utilities/utilities'

const frequency = require('@/information/frequency').default

export default {
  components: {
    ValidationProvider,
    ValidationObserver,
    BRow,
    BCol,
    BFormGroup,
    BFormInput,
    BForm,
    BButton,
    BCard,
    BFormCheckbox,
    BFormSelect,
  },
  directives: {
    Ripple,
  },
  props: {
    customer: {
      type: Object,
      default: null,
    },
  },
  data() {
    return {
      isForeigner: false,
      required,
      readOnlyCustomer: false,
      isLoading: false,
      daysExpirate: null,
      valueTotal: null,
      payerName: null,
      email: null,
      tax_id: null,
      hash: null,
      value: 'R$ 10,00',
      frequencyOptions: frequency,
      req: {
        product: {
          name: null,
          description: null,
        },
        payment: {
          value: 0,
          first_value: null,
          frequency: 1,
          period: null,
          start_date: null,
          expiration_date: null,
          failure_threshold: 15,
        },
      },
    }
  },
  created() {
    this.id = this.$route.query.cliente
    this.verifyObj()
  },
  methods: {
    async verifyObj() {
      if (this.customer.isTrue) {
        this.readOnlyCustomer = true
        this.req.customer_id = this.customer.customer_id
        this.payerName = this.customer.name
        this.email = this.customer.email
        this.tax_id = this.customer.tax_id
      }
    },
    error() {
      this.$swal({
        title: 'Erro na Criação do Link!',
        icon: 'error',
        timer: 2000,
        showConfirmButton: false,
        buttonsStyling: false,
      })
    },
    validationForm() {
      this.$refs.simpleRules.validate().then(success => {
        if (success) {
          this.createRecurrenceLink()
        }
      })
    },
    async createRecurrenceLink() {
      callLoading(true)
      const merchantId = Number(sessionStorage.getItem('veripagID'))
      if (!Number.isInteger(merchantId) || merchantId <= 0) {
        callLoading(false)
        this.$router.push({ name: 'select-merchant' })
        return
      }

      if (!this.customer.isTrue) {
        this.req.customer = {
          name: this.payerName,
          email: this.email,
          tax_id: this.tax_id,
        }
      }

      this.req.payment.value = +this.value.replace(/[R$.]/g, '').replace(',', '.')
      this.req.payment.first_value = this.req.payment.value

      this.req.merchant_id = merchantId

      try {
        const response = await generateLink('recurrence-link', this.req)
        if (response.status === 200) {
          this.hash = response.data.link.hash
          this.$router.push(
            `/recorrencia/confirmado/${this.hash}`,
          )
        } else {
          this.error()
        }
      } catch {
        this.error()
      } finally {
        callLoading(false)
      }
    },
  },
}
</script>

<style scoped lang="scss">
@import "@core/scss/base/pages/page-link-generator.scss";
</style>
